// Shared field styling for the Assets module forms so every entry screen
// matches the AssetTypeMasterForm look exactly.
export const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontSize: '14px',
  fontWeight: '500',
  color: '#495057'
}

export const inputStyle = {
  width: '100%',
  padding: '10px',
  border: '1px solid #e9ecef',
  borderRadius: '6px',
  fontSize: '14px',
  fontFamily: 'Inter, sans-serif'
}

export const textareaStyle = {
  ...inputStyle,
  resize: 'vertical'
}

export const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '20px'
}

export const sectionStyle = {
  marginBottom: '32px'
}

export const fullWidthStyle = {
  gridColumn: '1 / -1'
}

export const requiredStyle = {
  color: '#dc3545'
}
